<template>
  <a-card>
    <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
      <a-form-item label="职位名称" name="jobTitle">
        <DictSelect v-model:value="searchForm.jobTitle" :dict-name="education.HOPE_JOB" placeholder="请选择" />
        <!-- <a-input v-model:value="searchForm.jobTitle" placeholder="请输入" /> -->
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button @click="onReset">重置</a-button>
      </a-form-item>
    </a-form>
    <div class="table-toolbar">
      <a-button type="primary" @click="onAdd">
        <template #icon>
          <plus-outlined />
        </template>
        新增
      </a-button>
      <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)">
        <a-button danger>批量删除</a-button>
      </a-popconfirm>
    </div>
    <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
      <template #message>
        已选择 {{ selectedRowKeys.length }} 项
        <a @click="onClearSelected" class="ml-20 float-right">清空</a>
      </template>
    </a-alert>
    <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
      <template #jobTitle="{ record }">
        <a @click="onDetail(record)">
          <dict-render :dict-obj="dictObjs['hope_job']" :text="record.jobTitle"></dict-render>
        </a>
      </template>
      <template #industry="{ text }">
        <dict-render :dict-obj="dictObjs['research_field']" :text="text"></dict-render>
      </template>
      <template #educationBackground="{ text }">
        <dict-render :dict-obj="dictObjs['education_background']" :text="text"></dict-render>
      </template>
      <template #salary="{ text }">
        <dict-render :dict-obj="dictObjs['salary']" :text="text"></dict-render>
      </template>
      <template #workExperience="{ text }">
        <dict-render :dict-obj="dictObjs['work_experience']" :text="text"></dict-render>
      </template>
      <template #isShow="{ record }">
        <switch-btn :value="record.isShow" key-field="isShow" :switch-url="editUrl" :checkedValue="'0'"
          :uncheckedValue="'1'" :params="{ id: record.key }" @ok="loadData" />
      </template>
      <template #action="{ record }">
        <div class="table-row-operations">
          <a @click="onEdit(record)">编辑</a>
        </div>
      </template>
    </a-table>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
  <DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
</template>

<script>
import DetailModal from './components/DetailModal';
import UserModal from './components/UserModal';
import { dictMixin, tableListMixin } from "@/mixins";
import { enterpriseRrecruitmentInfo } from "@/api/educationService";
import DictRender from "@/components/other/DictRender";
import { education, dateFormat } from "@/config/variableConfig";
import { showCity } from "@/utils/util";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "职位名称", dataIndex: "jobTitle", key: "jobTitle", slots: { customRender: "jobTitle" } },
  // { title: '行业类型', dataIndex: "industry", key: "industry", slots: { customRender: "industry" } },
  { title: '学历', dataIndex: "educationBackground", key: "educationBackground", slots: { customRender: "educationBackground" } },
  { title: '薪资', dataIndex: "salary", key: "salary", slots: { customRender: "salary" } },
  { title: '工作经验', dataIndex: "workExperience", key: "workExperience", slots: { customRender: "workExperience" } },
  { title: "招聘人数", dataIndex: "numberRecruits", key: "numberRecruits" },
  { title: "是否招聘", dataIndex: "isShow", key: "isShow", slots: { customRender: "isShow" } },
  { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
  name: "index",
  mixins: [tableListMixin, dictMixin],
  components: {
    DetailModal, UserModal, DictRender
  },
  data() {
    return {
      education,
      dateFormat,
      dictNames: 'research_field,education_background,salary,work_experience,hope_job',
      columns,
      queryParam: {},
      listUrl: enterpriseRrecruitmentInfo.pageList,
      listKeyField: "id",
      deleteUrl: enterpriseRrecruitmentInfo.remove,
      editUrl: enterpriseRrecruitmentInfo.edit,
    }
  },
  methods: {
    onAdd() {
      this.onShowModal('userModal');
    },
    onEdit(record) {
      this.getAction({
        url: enterpriseRrecruitmentInfo.detail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('userModal', res);
      })
    },
    onDetail(record) {
      this.getAction({
        url: enterpriseRrecruitmentInfo.detail,
        params: { id: record.id }
      }).then(res => {
        let obj = {
          ...res,
          provject: showCity(res.prov, res.city, res.dist)
        }
        this.onShowModal('detailModal', obj);
      })
    },
  }
}
</script>

<style scoped></style>
